import React from 'react'
import DynamicColor from '../common/dynamic-color'
import Dropdown from '../elements/dropdown'
import DropdownItem from '../elements/dropdown/dropdown-item'

import paths from '../../routes/paths'
import { COLOR_NAME } from '../../constants'
import { useTranslation } from 'react-i18next'
import { getTodayTimework } from '../../utils'
import { clsx } from '../../utils/helper'

const HeadInfo = ({
    openLogin,
    user,
    handleLogout,
    restaurantInfo = {},
    setShowAccountModal,
    setShowUpdatePassword,
    toggleAdrMgr
}) => {
    const { t } = useTranslation()

    const Icon = props => (
        <DynamicColor
            // style={{ color: COLOR_NAME.LAYOUT_ICON }}
            tag="i"
            {...props}
        />
    )

    const todayTimeWork = getTodayTimework().filter(time => time !== '00:00-00:00')

    return (
        <DynamicColor
            // style={{ color: COLOR_NAME.LAYOUT_TEXT }}
            className="flex-between label-3 d-none d-lg-flex"
        >
            <div className="restaurant-info-details">
                <span>
                    <Icon className="mr-2 fas fa-map-marker-alt" />
                    {restaurantInfo.city}
                </span>

                <span>
                    <Icon className="mr-2 far fa-envelope" />
                    {restaurantInfo.settings?.email_shop}
                </span>

                <span>
                    <Icon className="mr-2 fas fa-phone" />
                    {restaurantInfo.hotline}
                </span>

                <span>
                    <Icon className="mr-2 far fa-clock" />
                    {/* {`${time_work.open} - ${time_work.close}`} */}
                    {todayTimeWork.map((el, index) => (
                        <span className={clsx(index !== 0 && 'ml-4')} key={index}>{el.replace('-', ' - ')}</span>
                    ))}
                </span>
            </div>

            {!!user ? (
                <Dropdown
                    position="bottom left"
                    dropdownListClass="mt-2"
                    toggleButton={
                        <div className="label-1 user-info">
                            <Icon className="fas fa-user-circle mr-2" />
                            <DynamicColor
                                style={{ color: COLOR_NAME.LAYOUT_TEXT }}
                            >
                                {user.userName}
                            </DynamicColor>
                        </div>
                    }
                >
                    {/* <DropdownItem tag={Link} to={paths.orderHistory}>
                        Đơn hàng của tôi
                    </DropdownItem> */}
                    <DropdownItem
                        // tag={Link}
                        // to={paths.updateProfile}
                        onClick={() => setShowAccountModal(true)}
                    >
                        {t('headerDesktop.btnUpdateUserInfo')}
                    </DropdownItem>
                    <DropdownItem
                        onClick={() => toggleAdrMgr(true)}
                    >
                        {t('headerDesktop.btnAddressMgr')}
                    </DropdownItem>
                    <DropdownItem
                        onClick={() => setShowUpdatePassword(true)}
                        // tag={Link}
                        // to={paths.updatePassword}
                    >
                        {t('headerDesktop.btnUpdatePassword')}
                    </DropdownItem>
                    <DropdownItem onClick={handleLogout}>
                        {t('headerDesktop.btnLogout')}
                    </DropdownItem>
                </Dropdown>
            ) : (
                <DynamicColor className="user-head__unlogin">
                    <div onClick={openLogin} className="btn-login">
                        <Icon className="fas mr-2 fa-sign-in-alt" />
                        {t('headerDesktop.btnLogin')}
                    </div>

                    <div className="separate-ver" />

                    <DynamicColor
                        // tag={Link}
                        to={paths.register}
                        className="btn-register"
                        onClick={() => setShowAccountModal(true)}
                    >
                        <Icon className="fas mr-2 fa-lock" />
                        {t('headerDesktop.btnRegister')}
                    </DynamicColor>
                </DynamicColor>
            )}
        </DynamicColor>
    )
}

export default HeadInfo
